import { NOTION_PROPERTY_TYPE_RICH_TEXT } from 'shared/lib/notion-constants';

const NOTION_BLOCK_TYPE_PARAGRAPH = 'paragraph';
const NOTION_BLOCK_TYPE_BULLETED_LIST_ITEM = 'bulleted_list_item';
const NOTION_BLOCK_TYPE_NUMBERED_LIST_ITEM = 'numbered_list_item';
const NOTION_BLOCK_TYPE_IMAGE = 'image';
const NOTION_BLOCK_TYPE_VIDEO = 'video';
const NOTION_BLOCK_TYPE_HEADING = 'heading';
const NOTION_BLOCK_TYPE_CODE = 'code';

const addAnnotations = (node) => {
  if (node.marks === undefined) {
    return {};
  }
  return node.marks.reduce((res, m) => {
    if (m.type === 'bold') {
      res.bold = true;
    }
    if (m.type === 'code') {
      res.code = true;
    }
    if (m.type === 'underline') {
      res.underline = true;
    }
    if (m.type === 'strike') {
      res.strikethrough = true;
    }
    if (m.type === 'italic') {
      res.italic = true;
    }
    return res;
  }, {});
};

const fixLink = (link, parentHost) => {
  const firstChar = link.slice(0, 1);
  if (firstChar === '/') {
    return `${parentHost}${link}`;
  }
  if (link.indexOf('http') !== 0) {
    return `https://${link}`;
  }
  return link;
};

const reduceBlock = (content, parentHost) => content.reduce((r, n) => {
  if (n.type !== 'text') {
    return r;
  }

  if (n.marks !== undefined) {
    const link = n.marks.find((m) => m.type === 'link');
    if (link !== undefined && link !== '') {
      r.push({
        type: 'text',
        text: { content: n.text, link: { url: fixLink(link.attrs.href, parentHost) } },
        annotations: addAnnotations(n),
      });
      return r;
    }
  }

  r.push({
    type: 'text',
    text: { content: n.text },
    annotations: addAnnotations(n),
  });
  return r;
}, []);

export const prosemirrorToNotion = (input, parentHost) => {
  if (input === null || !Array.isArray(input.content)) {
    return [];
  }
  return input.content.reduce((res, node) => {
    if (node.type === 'paragraph') {
      if (node.content === undefined) {
        return res;
      }
      if (node.content.length === 1 && node.content[0].marks !== undefined) {
        const link = node.content[0].marks.find((m) => m.type === 'link');
        if (link !== undefined && link.attrs.href === node.content[0].text && link.attrs.href.indexOf('youtube.com/watch') > -1) {
          res.push({
            type: 'video',
            video: {
              type: 'external',
              external: { url: link.attrs.href },
            },
          });
          return res;
        }
      }
      res.push({
        type: NOTION_BLOCK_TYPE_PARAGRAPH,
        [NOTION_BLOCK_TYPE_PARAGRAPH]: { rich_text: reduceBlock(node.content, parentHost) },
      });
      return res;
    }
    if (node.type === 'codeBlock') {
      if (node.content === undefined) {
        return res;
      }
      res.push({
        type: NOTION_BLOCK_TYPE_CODE,
        [NOTION_BLOCK_TYPE_CODE]: {
          caption: [],
          [NOTION_PROPERTY_TYPE_RICH_TEXT]: reduceBlock(node.content, parentHost),
          language: 'javascript',
        },
      });
    }
    if (node.type === 'bulletList') {
      node.content.forEach((n) => {
        n.content.forEach((c) => {
          res.push({
            type: NOTION_BLOCK_TYPE_BULLETED_LIST_ITEM,
            [NOTION_BLOCK_TYPE_BULLETED_LIST_ITEM]: { rich_text: reduceBlock(c.content, parentHost) },
          });
        });
      });
      return res;
    }
    if (node.type === 'orderedList') {
      node.content.forEach((n) => {
        n.content.forEach((c) => {
          res.push({
            type: NOTION_BLOCK_TYPE_NUMBERED_LIST_ITEM,
            [NOTION_BLOCK_TYPE_NUMBERED_LIST_ITEM]: { rich_text: reduceBlock(c.content, parentHost) },
          });
        });
      });
      return res;
    }
    if (node.type === 'image') {
      res.push({
        type: NOTION_BLOCK_TYPE_IMAGE,
        image: {
          type: 'external',
          external: { url: node.attrs.src },
        },
      });
    }
    if (node.type === 'video') {
      res.push({
        type: NOTION_BLOCK_TYPE_VIDEO,
        video: {
          type: 'external',
          external: { url: node.attrs.src },
        },
      });
    }
    if (node.type === 'heading') {
      res.push({
        type: `${NOTION_BLOCK_TYPE_HEADING}_${node.attrs.level}`,
        [`${NOTION_BLOCK_TYPE_HEADING}_${node.attrs.level}`]: { rich_text: reduceBlock(node.content, parentHost) },
      });
    }
    return res;
  }, []);
};

export const downloadURLToNotionBlocks = (screenshots) => {
  if (screenshots.length === 0) {
    return [];
  }

  return screenshots.reduce((res, url) => {
    res.push({
      type: NOTION_BLOCK_TYPE_IMAGE,
      image: {
        type: 'external',
        external: { url },
      },
    });
    return res;
  }, []);
};
